import { z } from 'zod';

const AnnouncementTypeSchema = z.union([
  z.literal('banner'),
  z.literal('non_dismissible_banner'),
  z.literal('dialog'),
]);

export const AnnouncementSchema = z.object({
  _id: z.string(),
  name: z.string(),
  content: z.object({
    type: AnnouncementTypeSchema,
    heading: z.string(),
    body: z.string(),
    ctaLabel: z.string().nullish(),
    ctaUrl: z.string().nullish(),
  }),
  start: z
    .object({
      date: z.string(),
      time: z.string(),
    })
    .optional()
    .nullable(),
  end: z
    .object({
      date: z.string(),
      time: z.string(),
    })
    .optional()
    .nullable(),
});

export type Announcement = z.infer<typeof AnnouncementSchema>;
